import { useState } from "react";

import { CopytraderCard, TradersList } from "./components";

import "./CopytradersTable.sass";
import { ReactComponent as FileWarning } from "@assets/images/icons/file-warning.svg";

const traders = [
  {
    name: "C1ltra",
    leverage: "Long 3.35x",
    isStarred: true,
    pnlPercent: "+43.32%",
    pnlValue: "+$221,653.40",
    copyTraders: 122,
    maxCopyTraders: 300,
    aum: "$21,653.40",
    daysLeading: 312,
    chartData: [
      10, 15, 25, 55, 45, 30, 55, 50, 45, 55, 55, 60, 40, 35, 45, 35, 35, 30,
      25, 30,
    ],
  },
  {
    name: "TraderX",
    leverage: "Short 2.10x",
    isStarred: false,
    pnlPercent: "+28.15%",
    pnlValue: "+$98,320.00",
    copyTraders: 87,
    maxCopyTraders: 200,
    aum: "$15,200.00",
    daysLeading: 198,
    chartData: [
      20, 18, 30, 40, 35, 50, 45, 60, 55, 50, 65, 70, 60, 55, 50, 45, 40, 35,
      30, 25,
    ],
  },
  {
    name: "AlphaWolf",
    leverage: "Long 5.00x",
    isStarred: false,
    pnlPercent: "+91.47%",
    pnlValue: "+$540,120.80",
    copyTraders: 299,
    maxCopyTraders: 300,
    aum: "$102,450.00",
    daysLeading: 521,
    chartData: [
      5, 20, 40, 60, 80, 75, 90, 85, 95, 100, 90, 85, 80, 75, 70, 65, 60, 55,
      50, 45,
    ],
  },
  {
    name: "NovaTrade",
    leverage: "Long 1.50x",
    isStarred: false,
    pnlPercent: "+12.80%",
    pnlValue: "+$32,100.00",
    copyTraders: 45,
    maxCopyTraders: 150,
    aum: "$8,750.00",
    daysLeading: 87,
    chartData: [
      30, 28, 32, 35, 30, 28, 33, 36, 34, 38, 35, 33, 36, 40, 38, 35, 33, 30,
      28, 25,
    ],
  },
  {
    name: "CryptoKing",
    leverage: "Short 3.00x",
    isStarred: false,
    pnlPercent: "-8.34%",
    pnlValue: "-$18,450.00",
    copyTraders: 33,
    maxCopyTraders: 100,
    aum: "$5,300.00",
    daysLeading: 54,
    chartData: [
      60, 55, 50, 45, 40, 35, 30, 28, 25, 20, 22, 18, 15, 20, 18, 15, 12, 10, 8,
      5,
    ],
  },
  {
    name: "StellarFX",
    leverage: "Long 2.75x",
    isStarred: false,
    pnlPercent: "+55.60%",
    pnlValue: "+$310,980.50",
    copyTraders: 178,
    maxCopyTraders: 250,
    aum: "$67,800.00",
    daysLeading: 402,
    chartData: [
      15, 20, 25, 30, 40, 50, 55, 60, 65, 70, 68, 72, 75, 80, 78, 82, 85, 88,
      90, 95,
    ],
  },
  {
    name: "ZenTrader",
    leverage: "Long 1.80x",
    isStarred: false,
    pnlPercent: "+22.10%",
    pnlValue: "+$75,340.00",
    copyTraders: 96,
    maxCopyTraders: 200,
    aum: "$28,900.00",
    daysLeading: 233,
    chartData: [
      25, 30, 28, 35, 32, 38, 36, 40, 38, 42, 40, 45, 43, 48, 46, 50, 48, 52,
      50, 55,
    ],
  },
  {
    name: "BitMaster",
    leverage: "Short 4.20x",
    isStarred: false,
    pnlPercent: "+67.90%",
    pnlValue: "+$421,760.00",
    copyTraders: 241,
    maxCopyTraders: 300,
    aum: "$89,500.00",
    daysLeading: 478,
    chartData: [
      10, 20, 35, 50, 65, 60, 75, 80, 70, 85, 90, 88, 92, 95, 90, 88, 85, 80,
      75, 70,
    ],
  },
  {
    name: "MoonShot",
    leverage: "Long 6.00x",
    isStarred: false,
    pnlPercent: "+134.50%",
    pnlValue: "+$892,340.00",
    copyTraders: 300,
    maxCopyTraders: 300,
    aum: "$210,000.00",
    daysLeading: 612,
    chartData: [
      5, 10, 20, 40, 60, 80, 100, 95, 110, 120, 115, 125, 130, 128, 135, 140,
      138, 145, 150, 155,
    ],
  },
  {
    name: "DarkPool",
    leverage: "Short 2.50x",
    isStarred: false,
    pnlPercent: "-15.20%",
    pnlValue: "-$42,800.00",
    copyTraders: 21,
    maxCopyTraders: 100,
    aum: "$4,100.00",
    daysLeading: 31,
    chartData: [
      50, 45, 42, 38, 35, 30, 28, 25, 22, 20, 18, 15, 18, 15, 12, 10, 12, 10, 8,
      5,
    ],
  },
  {
    name: "QuantFi",
    leverage: "Long 3.90x",
    isStarred: false,
    pnlPercent: "+48.75%",
    pnlValue: "+$198,650.00",
    copyTraders: 155,
    maxCopyTraders: 250,
    aum: "$54,300.00",
    daysLeading: 344,
    chartData: [
      20, 25, 30, 28, 35, 40, 38, 45, 50, 48, 55, 60, 58, 65, 70, 68, 75, 80,
      78, 85,
    ],
  },
  {
    name: "PeakFlow",
    leverage: "Long 2.20x",
    isStarred: false,
    pnlPercent: "+33.40%",
    pnlValue: "+$121,450.00",
    copyTraders: 112,
    maxCopyTraders: 200,
    aum: "$38,700.00",
    daysLeading: 267,
    chartData: [
      15, 18, 22, 25, 28, 32, 30, 35, 38, 36, 40, 42, 40, 45, 48, 46, 50, 52,
      50, 55,
    ],
  },
];

export const CopytradersTable = ({ activeMainTab }) => {
  const tabs = [
    "Top Balanced Traders",
    "Top ROI",
    "Top Intra Day Traders",
    "Top New Talents",
    "Highest Follower Profit",
    "Lowest Drawdown",
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const filteredTraders = traders.filter((trader) => {
    if (activeMainTab === "Favorites") return trader.isStarred === true;
    if (activeMainTab === "Subscribed") return false;
    return true;
  });

  const isLeaderboard = activeMainTab === "Leaderboard";
  const isAllTraders = activeMainTab === "All Traders";

  return (
    <div className="copytraders-table">
      {isLeaderboard && (
        <>
          <ul className="copytraders-table__sort">
            {tabs.map((tab) => (
              <li
                key={tab}
                className={`copytraders-table__sort-item ${
                  activeTab === tab
                    ? "copytraders-table__sort-item--active"
                    : ""
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </li>
            ))}
          </ul>
          <p className="copytraders-table__sort-description">
            Traders that have earned the highest ROI in the last 7 days.
          </p>
        </>
      )}

      {filteredTraders.length === 0 ? (
        <div className="copytraders-table__empty">
          <FileWarning />
          <p>No Results Found</p>
        </div>
      ) : isAllTraders ? (
        <TradersList data={filteredTraders} />
      ) : (
        <div className="copytraders-table__content">
          {filteredTraders.map((trader, i) => (
            <div key={i}>
              <CopytraderCard {...trader} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
